'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;

var _set_day = require('date-fns/set_day');

var _set_day2 = _interopRequireDefault(_set_day);

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

var _en = require('date-fns/locale/en');

var _en2 = _interopRequireDefault(_en);

var _es = require('date-fns/locale/es');

var _es2 = _interopRequireDefault(_es);

var _pt = require('date-fns/locale/pt');

var _pt2 = _interopRequireDefault(_pt);

var _fr = require('date-fns/locale/fr');

var _fr2 = _interopRequireDefault(_fr);

var _de = require('date-fns/locale/de');

var _de2 = _interopRequireDefault(_de);

var _pl = require('date-fns/locale/pl');

var _pl2 = _interopRequireDefault(_pl);

var _it = require('date-fns/locale/it');

var _it2 = _interopRequireDefault(_it);

var _ru = require('date-fns/locale/ru');

var _ru2 = _interopRequireDefault(_ru);

var _ja = require('date-fns/locale/ja');

var _ja2 = _interopRequireDefault(_ja);

var _ko = require('date-fns/locale/ko');

var _ko2 = _interopRequireDefault(_ko);

var _tr = require('date-fns/locale/tr');

var _tr2 = _interopRequireDefault(_tr);

var _sv = require('date-fns/locale/sv');

var _sv2 = _interopRequireDefault(_sv);

var _nl = require('date-fns/locale/nl');

var _nl2 = _interopRequireDefault(_nl);

var _da = require('date-fns/locale/da');

var _da2 = _interopRequireDefault(_da);

var _nb = require('date-fns/locale/nb');

var no = _interopRequireWildcard(_nb);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var locales = {
  en: _en2.default,
  es: _es2.default,
  pt: _pt2.default,
  fr: _fr2.default,
  de: _de2.default,
  pl: _pl2.default,
  it: _it2.default,
  ru: _ru2.default,
  ja: _ja2.default,
  ko: _ko2.default,
  tr: _tr2.default,
  sv: _sv2.default,
  no: no,
  nl: _nl2.default,
  da: _da2.default
};

function formatDate(date, dateFormat, locale) {
  return (0, _format2.default)(date, dateFormat, { locale: locales[locale] });
}

exports.default = function (locale) {
  return {
    formatMonthTitle: function formatMonthTitle(date) {
      return (0, _format2.default)(date, 'MMMM YYYY', {
        locale: locales[locale]
      });
    },

    formatWeekdayShort: function formatWeekdayShort(index) {
      return (0, _format2.default)((0, _set_day2.default)(new Date(), index), 'dd', {
        locale: locales[locale]
      });
    },

    formatWeekdayLong: function formatWeekdayLong(index) {
      return (0, _format2.default)((0, _set_day2.default)(new Date(), index), 'dddd', {
        locale: locales[locale]
      });
    },

    formatDay: function formatDay(date) {
      return (0, _format2.default)(date, 'ddd ll', {
        locale: locales[locale]
      });
    },

    getMonths: function getMonths() {
      return [].concat(_toConsumableArray(Array(12).keys())).map(function (i) {
        return (0, _format2.default)(new Date(2018, i), 'MMMM', { locale: locales[locale] });
      });
    }
  };
};